import { Component, ContentChild, TemplateRef } from '@angular/core';

@Component({
  selector: 'app-grid-column-header',
  template: '',
  standalone: false,
})
export class GridColumnHeaderComponent {
  @ContentChild(TemplateRef) template: TemplateRef<{}>;
}
